"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@folio/stripes/components");
var _hooks = require("../../hooks");
var _CustomPropertyCard = _interopRequireDefault(require("./CustomPropertyCard"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CustomPropertiesViewCtx = _ref => {
  var _custprops$filter$len, _custprops$filter;
  let {
    ctx,
    customProperties = [],
    customPropertiesEndpoint,
    id,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {}
  } = _ref;
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);

  // Deal with all the possible label override options
  const getAccordionLabel = () => {
    // Special case for null context
    if (ctx === 'isNull') {
      return kintIntl.formatKintMessage({
        id: 'customProperties',
        overrideValue: labelOverrides.noContext
      });
    }

    // Chain formatKintMessages together using provided fallbackMessage to
    // allow for "If override or translation exists, use it, else use default"
    return kintIntl.formatKintMessage({
      id: "customProperties.ctx.".concat(ctx),
      overrideValue: labelOverrides[ctx],
      fallbackMessage: kintIntl.formatKintMessage({
        id: 'customProperties.defaultTitle',
        overrideValue: labelOverrides.defaultTitle
      }, {
        ctx
      })
    }, {
      ctx
    });
  };
  const {
    data: custprops,
    isLoading
  } = (0, _hooks.useCustomProperties)({
    ctx,
    endpoint: customPropertiesEndpoint,
    returnQueryObject: true,
    options: {
      sort: [{
        path: 'retired'
      },
      // Place retired custprops at the end
      {
        path: 'primary',
        direction: 'desc'
      },
      // Primary properties should display before optional
      {
        path: 'weight'
      },
      // Within those groups, sort by weight
      {
        path: 'label'
      } // For those with the same weight, sort by label
      ]
    }
  });
  if (isLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Accordion, {
      closedByDefault: true,
      displayWhenClosed: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Spinner, {}),
      displayWhenOpen: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Spinner, {}),
      id: "".concat(id, "-accordion-").concat(ctx),
      label: getAccordionLabel(),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Spinner, {})
    });
  }
  const countSetProperties = primary => {
    var _Object$entries$filte, _Object$entries;
    return (_Object$entries$filte = (_Object$entries = Object.entries(customProperties)) === null || _Object$entries === void 0 || (_Object$entries = _Object$entries.filter(_ref2 => {
      var _cp$, _cp$2, _cp$3;
      let [_key, cp] = _ref2;
      return (((_cp$ = cp[0]) === null || _cp$ === void 0 || (_cp$ = _cp$.type) === null || _cp$ === void 0 ? void 0 : _cp$.ctx) === ctx || ctx === 'isNull' && !((_cp$2 = cp[0]) !== null && _cp$2 !== void 0 && (_cp$2 = _cp$2.type) !== null && _cp$2 !== void 0 && _cp$2.ctx)) &&
      // Either the ctx string matches, or isNull matches blank
      ((_cp$3 = cp[0]) === null || _cp$3 === void 0 || (_cp$3 = _cp$3.type) === null || _cp$3 === void 0 ? void 0 : _cp$3.primary) === primary // Only count non-primary set custprops
      ;
    })) === null || _Object$entries === void 0 ? void 0 : _Object$entries.length) !== null && _Object$entries$filte !== void 0 ? _Object$entries$filte : 0;
  };

  // We need to display any set properties, along with any non-set primary properties
  const primaryCount = (_custprops$filter$len = custprops === null || custprops === void 0 || (_custprops$filter = custprops.filter(cp => cp.primary === true)) === null || _custprops$filter === void 0 ? void 0 : _custprops$filter.length) !== null && _custprops$filter$len !== void 0 ? _custprops$filter$len : 0;
  const optionalCount = countSetProperties(false);
  const setPrimaryCount = countSetProperties(true);
  return primaryCount + optionalCount > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Accordion, {
    closedByDefault: true,
    displayWhenClosed: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Badge, {
      children: setPrimaryCount + optionalCount
    }),
    displayWhenOpen: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Badge, {
      children: setPrimaryCount + optionalCount
    }),
    id: "".concat(id, "-accordion-").concat(ctx),
    label: getAccordionLabel(),
    children: custprops.map((cp, index) => {
      var _customProperties$cp$;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomPropertyCard.default, {
        ctx: ctx,
        customProperty: customProperties === null || customProperties === void 0 || (_customProperties$cp$ = customProperties[cp.name]) === null || _customProperties$cp$ === void 0 ? void 0 : _customProperties$cp$[0],
        customPropertyDefinition: cp,
        index: index,
        labelOverrides: labelOverrides
      }, "custom-property-card-".concat(ctx, "[").concat(index, "]"));
    })
  });
};
CustomPropertiesViewCtx.propTypes = {
  ctx: _propTypes.default.string,
  customProperties: _propTypes.default.object,
  customPropertiesEndpoint: _propTypes.default.string,
  id: _propTypes.default.string,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object
};
var _default = exports.default = CustomPropertiesViewCtx;